export default "__VITE_ASSET__C7v726J4__"